import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import { faGears } from "@fortawesome/free-solid-svg-icons"
import './dashCSS.css'



export default function DashAvisos(){

    
    return (
    
<>
    <center>
        {/* Container principal do card deve estar aqui, presumindo que <center> está dentro de uma div do tipo card */}
        
        {/* Seção do Título e Ícone - Aparentemente está OK para o cabeçalho */}
        <div className='containerDash'> 
            <div>
                <h5>Atualizações</h5>
                <h6>25/01/2025</h6>
            </div>
            <div><FontAwesomeIcon icon={faGears} size='xl' /></div>
        </div>
        
        {/* SEÇÃO DO CONTEÚDO (Substituindo <tr> e <td> por <div>) */}
        {/* Você precisa da classe que define o estilo do corpo do card, vamos usar 'card-body' ou 'containerTexto' se ela fizer o papel */}
        <div className='containerTexto'>
            <ol> 
                <br />
                <li>Melhor Navegação na Ficha Paciente</li> 
            </ol>
        </div>
            
    </center>
</> 
   
    )
}

